'use client';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import CategoriesSection from './CategoriesSection';
import PromotionalBannersSection from './PromotionalBannersSection';
import NewArrivalsSection from './NewArrivalsSection';
import TopBrandsSection from './TopBrandsSection';
import TestimonialsSection from './TestimonialsSection';
import BlogSection from './BlogSection';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

export default function HomePage() {
    return (
        <>
            <Header />
            <main className="w-full bg-background-tertiary">
                <HeroSection />
                <FeaturesSection />
                <CategoriesSection />
                <PromotionalBannersSection />
                <NewArrivalsSection />
                <TopBrandsSection />
                <TestimonialsSection />
                <BlogSection />
            </main>
            <Footer />
        </>
    )
}